import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EmptyMessage } from "./styles";
import FlowCard from './../../../../CommonComponents/FlowCard/FlowCard';

class CardComponent extends Component {

  styleConfig() {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardDivider: true,
      cardPadding: true,
    };
  }

  render() {
    let emptyStateText = '';
    if (this.props.tabName && !this.props.searchText) {
      switch (this.props.tabName) {
        case "contributions":
          emptyStateText = `There are no contributions for the selected time frame.`
          break;
        case "grants":
          emptyStateText = `There are no grants for the selected time frame.`
          break;
        case "exchange":
          emptyStateText = `There are no exchanges for the selected time frame.`
          break;
        case "other_transactions":
          emptyStateText = `There are no other transactions for the selected time frame.`
          break;
        case "all_transactions":
          emptyStateText = `There are no transactions for the selected time frame.`
          break;
        case "account_balance":
          emptyStateText = `There is no account balance history for the selected time frame.`
          break;
        default:
          emptyStateText = `There are no transactions for the selected time frame.`
          break;
      }
    } else {
      emptyStateText = `No Search Results Found`
    }
    if (this.props.data && this.props.data.length > 0) {
      return (
        <div data-test="flowcard">
          {this.props.data.map((each, index) =>
            (
              <FlowCard
                cardConfig={this.props.destObj(each, index)}
                index={index}
                styleConfig={this.styleConfig()}
                scrollId="fromFlowCard"
              />
            )
          )}
        </div>
      );
    } else {
      return (
        <div class='ant-empty ant-empty-normal' data-test="flowcard-empty">
          <EmptyMessage class='ant-empty-description'>
            <div>{emptyStateText}</div>
          </EmptyMessage>
        </div>
      );
    }

  }
}

CardComponent.propTypes = {
  searchText: PropTypes.string,
  tabName: PropTypes.string,
  destObj: PropTypes.func.isRequired,
  data: PropTypes.array
}

export default CardComponent;